export const LOGGED = 'LOGGED'
export const NOT_LOGGED_IN = 'NOT_LOGGED_IN'
export const LOGIN_MODAL = 'LOGIN_MODAL'

export const logged = userData => ({
    type: LOGGED,
    payload: userData
})

export const notLoggedIn = data => ({
    type: NOT_LOGGED_IN,
    payload: null
})

export const modalLogin = () => ({
    type: LOGIN_MODAL,
    payload: true
})

export const closedModalLogin = () => ({
    type: LOGIN_MODAL,
    payload: false
})


// WEBPACK FOOTER //
// ./src/store/actions/user.js